import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 sm:gap-3 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/982cbef0933d5cb0c5a33b0250e14312/63919f1218177b7717c8f3f0981d9dd4.png"
              alt="赤ちゃんダイアリー"
              className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg"
            />
            <span
              className={`text-lg sm:text-xl font-bold font-maru transition-colors ${
                isScrolled ? 'text-text-primary' : 'text-white'
              }`}
            >
              赤ちゃんダイアリー
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled
                  ? 'text-text-secondary hover:text-text-primary'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              ホーム
            </Link>
            <Link
              to="/terms"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled
                  ? 'text-text-secondary hover:text-text-primary'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              利用規約
            </Link>
            <Link
              to="/privacy"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled
                  ? 'text-text-secondary hover:text-text-primary'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              プライバシーポリシー
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled
                  ? 'text-text-secondary hover:text-text-primary'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              お問い合わせ
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-text-primary' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 py-4">
            <div className="flex flex-col gap-4">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-sm font-medium text-text-secondary hover:text-text-primary transition-colors cursor-pointer text-left px-4 py-2 whitespace-nowrap"
              >
                ホーム
              </Link>
              <Link
                to="/terms"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-sm font-medium text-text-secondary hover:text-text-primary transition-colors cursor-pointer text-left px-4 py-2 whitespace-nowrap"
              >
                利用規約
              </Link>
              <Link
                to="/privacy"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-sm font-medium text-text-secondary hover:text-text-primary transition-colors cursor-pointer text-left px-4 py-2 whitespace-nowrap"
              >
                プライバシーポリシー
              </Link>
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-sm font-medium text-text-secondary hover:text-text-primary transition-colors cursor-pointer text-left px-4 py-2 whitespace-nowrap"
              >
                お問い合わせ
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;